module.exports = __webpack_public_path__ + "assets/img/one1.60985e20.png";